import * as $ from 'jquery';
import { SaveButton } from '../../../../itrust_common/components/others'
import { useHistory } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { patientCreate, patientEditCancel } from '../../../../redux/actions/patient/patientActions'
import { quickActions, quickActionsReset } from '../../../../redux/actions/dashboard/quickActionActions'
import Appointment from '../../appointment/Appointment';
import SelectPatientModal from './SelectPatientModal';
import PrescriptionModal from '../../../../components/authorised/prescriptions/PrescriptionModal';
import SelectPrescriptionProvider from '../../../../components/authorised/prescriptions/SelectPrescriptionProvider';
import AddActionDropdown from './AddActionDropdown';
import { currentUserUpdate } from '../../../../itrust_common/redux/actions/authActions';
import PatientFullMode from './PatientFullMode';
import SecondaryPatientForm from './SecondaryPatientForm';
import { reset, submit } from 'redux-form';

function MoreActionModals(props) {
  const { patientSaving, quickAction, quickActionEnable, appointmentEdit } = props
  const history = useHistory()
  const dispatch = useDispatch()

  const handleCreatePatient = async (data) => {
    let res = await dispatch(patientCreate(data))
    res = res.value.data.patient
    handlePatientEditCancel(res)
  }

  const handlePatientEditCancel = (patient) => {
    dispatch(patientEditCancel());
    $('#quickActionPatientForm-modal').modal('hide');
    dispatch(quickActions({ select_patient_modal: false }))
    patient.id && history.push(`/patients/${patient?.id}/overview`)
    dispatch(quickActionsReset())
    dispatch(reset('secondaryPatientForm'))
  }

  const handleUpdateQuickActions = (data) => {
    dispatch(currentUserUpdate(data, { include: ['address'] }))
  }

  const handleFullMode = () => {
    setTimeout(() => $('#fullModePatient-modal').modal({ backdrop: 'static', keyboard: false }), 300);
  }

  return (
    <>
      <SelectPatientModal />
      {/* For quick action appointments + Dashboard edit appointment */}
      {(quickAction.select_patient_modal == 'appointment' || appointmentEdit?.id) && <Appointment isQuickAction={quickAction.select_patient_modal == 'appointment'} />}
      {quickAction.select_patient_modal == 'patient' && <>
        <div className="modal" id="quickActionPatientForm-modal" data-backdrop="static">
          <div className="modal-dialog rounded modal-lg bg-white">
            <div className="modal-content rounded">
              <div className="modal-header">
                <h5 className="text-dark">New Patient</h5>
                <div className='d-flex'>
                  <button className='btn btn-primary' onClick={handleFullMode}>Full Mode</button>
                  <button type="button" className="btn btn-outline-primary mx-5" onClick={handlePatientEditCancel}>Close</button>
                  <SaveButton saving={patientSaving} handleOnClick={() => dispatch(submit('secondaryPatientForm'))} />
                </div>
              </div>
              <div className="modal-body p-0">
                {quickAction.patient?.id && <SecondaryPatientForm
                  onSubmit={handleCreatePatient}
                  initialValues={quickAction.patient ?? {}}
                  isLongForm={false}
                />}
              </div>
            </div>
          </div>
        </div>

        {/* <ModalFormWrapper
          formName="secondaryPatientForm"
          saving={patientSaving}
          formTitle="New Patient"
          handleEditCancel={handlePatientEditCancel}
          modalContentClasses="patient-step-3"
          savingBtnClasses="quick-action-patient-btns"
        >
          <div className='align-full-mode-btn position-absolute'>
            <button className='btn btn-primary mr-3' onClick={handleFullMode}>Full Mode</button>
          </div>
          {quickAction.patient?.id && <SecondaryPatientForm
            onSubmit={handleCreatePatient}
            initialValues={quickAction.patient ?? {}}
            isLongForm={false}
          />}
        </ModalFormWrapper> */}
      </>}
      {quickAction.select_patient_modal == 'prescription' && <>
        <SelectPrescriptionProvider />
      </>}
      <PrescriptionModal />
      {quickActionEnable && <AddActionDropdown onSubmit={handleUpdateQuickActions} />}
      {['patient', 'order', 'exam'].includes(quickAction.select_patient_modal) && <PatientFullMode patient={quickAction.patient} />}
    </>
  )
}

const mapStateToProps = (state) => {
  const { dashboard: { quickAction }, patient, auth, appointment } = state
  return {
    quickAction,
    patientSaving: patient.saving,
    quickActionEnable: auth.user?.preferences?.accessibility?.quick_actions,
    appointmentEdit: appointment.editing
  }
}

export default connect(mapStateToProps)(MoreActionModals)
